var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsynCardContainer',{attrs:{"loading":_vm.loading,"sizes":{
    default: 12,
    sm: 12,
    lg: 6
  },"visibleCard":""}},[_c('div',{staticClass:"card-header-custom pt-4"},[_c('h5',{staticClass:"card-title mb-0 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"w-100 d-flex flex-column align-items-center"},[(!_vm.hasData)?[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$tc("NO_DATA_FOUND")))])]:_vm._e(),(_vm.hasData)?[_c('ApacheEchart',{staticClass:"w-100",style:(`min-height: 320px;`),attrs:{"id":_vm.idGraph,"options":_vm.optionsGraph}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }